var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileBackdrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 210,
    viewBox: "0 0 180 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 210,
    rx: 6,
    fill: "#5E6062"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    transform: "translate(56 71)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.804 96.4717L109.833 99.3475V124.833C109.833 126.336 109.236 127.778 108.173 128.84C107.11 129.903 105.669 130.5 104.166 130.5H75.8327C74.3298 130.5 72.8884 129.903 71.8257 128.84C70.763 127.778 70.166 126.336 70.166 124.833V85.1667C70.166 83.6638 70.763 82.2224 71.8257 81.1597C72.8884 80.097 74.3298 79.5 75.8327 79.5H90.7785C92.1073 79.5 93.3908 79.9647 94.4108 80.8147L108.787 92.8167C109.43 93.355 109.804 94.1512 109.804 94.9927V96.4688V96.4717ZM90.056 85.1667L89.9993 94.2107C89.999 94.5802 90.0716 94.9462 90.2131 95.2876C90.3546 95.629 90.5622 95.939 90.8239 96.2C91.0856 96.4609 91.3963 96.6675 91.7381 96.808C92.0799 96.9484 92.4461 97.02 92.8157 97.0185H104.149L90.056 85.1667Z",
    fill: "#8C8D8E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBackdrop);
export default __webpack_public_path__ + "static/media/fileBackdrop.6cc259daf56bb5c5dc8b2a585b5c01cf.svg";
export { ForwardRef as ReactComponent };